var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 21.0834C5.90576 19.9513 1.83301 15.1452 1.83301 10.0834V4.58342L10.9997 0.916748L20.1663 4.58342V10.0834C20.1663 15.1471 16.0936 19.9513 10.9997 21.0834ZM3.66634 5.50008V10.0834C3.71873 12.2029 4.46417 14.2468 5.78859 15.9023C7.113 17.5578 8.94342 18.7337 10.9997 19.2501C13.0559 18.7337 14.8863 17.5578 16.2108 15.9023C17.5352 14.2468 18.2806 12.2029 18.333 10.0834V5.50008L10.9997 2.75008L3.66634 5.50008Z",
    fill: "#2563EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 10.0833C12.2653 10.0833 13.2913 9.05732 13.2913 7.79167C13.2913 6.52601 12.2653 5.5 10.9997 5.5C9.73402 5.5 8.70801 6.52601 8.70801 7.79167C8.70801 9.05732 9.73402 10.0833 10.9997 10.0833Z",
    fill: "#2563EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41699 13.75C6.86866 14.5735 7.5311 15.2621 8.33647 15.7453C9.14184 16.2285 10.0612 16.489 11.0003 16.5C11.9395 16.489 12.8588 16.2285 13.6642 15.7453C14.4695 15.2621 15.132 14.5735 15.5837 13.75C15.5607 12.012 12.5202 11 11.0003 11C9.47224 11 6.43991 12.012 6.41699 13.75Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAdminIcon);
export default __webpack_public_path__ + "static/media/active-admin-icon.e4a912de7197d7701c9b37aaabdfe1f3.svg";
export { ForwardRef as ReactComponent };